var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHamburgerUi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 26.5 20.266"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Hamburger UI",
  fill: "none",
  stroke: "#f96506",
  strokeLinecap: "round",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 869",
  d: "M1.25 1.25h24"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 870",
  d: "M1.25 10.133h24"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 871",
  d: "M1.25 19.016h16"
}))));
export default __webpack_public_path__ + "static/Hamburger-UI.3ed5b70040ca50d1b935e103adec73e1.svg";
export { SvgHamburgerUi as ReactComponent };